import React, { useEffect, useRef } from "react";
import { Table } from "antd";

const CustomTable = ({ columns, dataSource, linkHeads = [], summary, ...rest }) => {
  const wrapperRef = useRef(null);
  const topScrollRef = useRef(null);

  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper) return;

    const tableBody = wrapper.querySelector(".ant-table-body");
    const topScroll = topScrollRef.current;
    const topInner = topScroll?.firstChild;

    if (!tableBody || !topScroll || !topInner) return;

    // Set correct scroll width
    topInner.style.width = tableBody.scrollWidth + "px";

    const syncTop = () => {
      tableBody.scrollLeft = topScroll.scrollLeft;
    };

    const syncTable = () => {
      topScroll.scrollLeft = tableBody.scrollLeft;
    };

    topScroll.addEventListener("scroll", syncTop);
    tableBody.addEventListener("scroll", syncTable);

    return () => {
      topScroll.removeEventListener("scroll", syncTop);
      tableBody.removeEventListener("scroll", syncTable);
    };
  }, [dataSource, columns]);

  return (
    <div ref={wrapperRef}>
      
      

      <Table
        dataSource={dataSource}
        columns={columns}
        bordered
        className="custom-ant-table"  // ✅ unchanged
        pagination={false}
        scroll={{ x: "max-content", y: 500 }}
        summary={summary}
        {...rest}
      />
    </div>
  );
};

export default CustomTable;